import { HeatConfig, HeatResult } from "graphql/generated/types";
import { PendingLeaderboardFields } from "components/events/judging/pending/usePendingLeaderboard";
import { Result } from "models/Result";

export function isPendingRide(result: Pick<HeatResult, "rides">) {
    return Object.values(result.rides || {}).some(
        (judgeScores: any) => judgeScores.some(
            (score: any) => score.pending,
        )
    );
}

export function getFirstPendingRide(result: Pick<HeatResult, "rides">): HeatResult["rides"][number] | undefined {
    for (const ride of Object.values(result.rides || {})) {
        for (const score of ride) {
            if (score.pending) {
                return score;
            }
        }
    }
    return undefined;
}

export function getFirstModifierType(result: Pick<HeatResult, "rides">): string | null {
    for (const ride of Object.values(result.rides || {})) {
        for (const score of ride) {
            if (score.modifier && score.modifier.type) {
                return score.modifier.type;
            }
        }
    }
    return null;
}

export function usePendingResultChanges(
    result: PendingLeaderboardFields["result"][number],
    pendingResult: PendingLeaderboardFields["result"][number],
    heatConfig: Pick<HeatConfig, "calculator">,
) {
    const _result = Result(result);
    const _pendingResult = Result(pendingResult);

    const pendingPlace = Number(_pendingResult.place);
    const approvedPlace = Number(_result.place);
    const placeChange =
        !Number.isNaN(pendingPlace) && !Number.isNaN(approvedPlace)
            ? pendingPlace - approvedPlace
            : 0;

    const pendingPlaceToDisplay = _pendingResult.placeToDisplay();
    const approvedPlaceToDisplay = _result.placeToDisplay();

    return {
        place: {
            pending: pendingPlaceToDisplay.place,
            approved: approvedPlaceToDisplay.place,
            change: placeChange,
        },
        formattedTotal: {
            pending: _pendingResult.formattedTotal(heatConfig),
            approved: _result.formattedTotal(heatConfig),
        },
    };
}
